/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Change_StaleInputs */

const en_plan_change_stale = /** @type {(inputs: Plan_Change_StaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The amounts changed. Please review again.`)
};

const es_plan_change_stale = /** @type {(inputs: Plan_Change_StaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los importes cambiaron. Revísalos de nuevo.`)
};

/**
* | output |
* | --- |
* | "The amounts changed. Please review again." |
*
* @param {Plan_Change_StaleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_change_stale = /** @type {((inputs?: Plan_Change_StaleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Change_StaleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_change_stale(inputs)
	return en_plan_change_stale(inputs)
});